import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { Department } from './department.model';

export enum DepartmentActionTypes {
  LoadDepartments = '[Department] Load Departments',
  AddDepartment = '[Department] Add Department',
  UpsertDepartment = '[Department] Upsert Department',
  AddDepartments = '[Department] Add Departments',
  UpsertDepartments = '[Department] Upsert Departments',
  UpdateDepartment = '[Department] Update Department',
  UpdateDepartments = '[Department] Update Departments',
  DeleteDepartment = '[Department] Delete Department',
  DeleteDepartments = '[Department] Delete Departments',
  ClearDepartments = '[Department] Clear Departments',
}

export class LoadDepartments implements Action {
  readonly type = DepartmentActionTypes.LoadDepartments;

  constructor(public payload: { departments: Department[] }) {}
}

export class AddDepartment implements Action {
  readonly type = DepartmentActionTypes.AddDepartment;

  constructor(public payload: { department: Department }) {}
}

export class UpsertDepartment implements Action {
  readonly type = DepartmentActionTypes.UpsertDepartment;

  constructor(public payload: { department: Department }) {}
}

export class AddDepartments implements Action {
  readonly type = DepartmentActionTypes.AddDepartments;

  constructor(public payload: { departments: Department[] }) {}
}

export class UpsertDepartments implements Action {
  readonly type = DepartmentActionTypes.UpsertDepartments;

  constructor(public payload: { departments: Department[] }) {}
}

export class UpdateDepartment implements Action {
  readonly type = DepartmentActionTypes.UpdateDepartment;

  constructor(public payload: { department: Update<Department> }) {}
}

export class UpdateDepartments implements Action {
  readonly type = DepartmentActionTypes.UpdateDepartments;

  constructor(public payload: { departments: Update<Department>[] }) {}
}

export class DeleteDepartment implements Action {
  readonly type = DepartmentActionTypes.DeleteDepartment;

  constructor(public payload: { id: string }) {}
}

export class DeleteDepartments implements Action {
  readonly type = DepartmentActionTypes.DeleteDepartments;

  constructor(public payload: { ids: string[] }) {}
}

export class ClearDepartments implements Action {
  readonly type = DepartmentActionTypes.ClearDepartments;
}

export type DepartmentActions =
  | LoadDepartments
  | AddDepartment
  | UpsertDepartment
  | AddDepartments
  | UpsertDepartments
  | UpdateDepartment
  | UpdateDepartments
  | DeleteDepartment
  | DeleteDepartments
  | ClearDepartments;
